import APIClient from '@/shared/http/clients/api'

const resourceName = 'hsm'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=createdAt,desc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=createdAt,desc&page=${index}&size=${limit}`, config)

const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)



const SaveVideo = (hsmId, videoId, config = {}) =>
  APIClient.post(`${APICore}/${resourceName}/${hsmId}/video`, { videoId }, config)

const HsmRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  SaveVideo
}

export default HsmRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/hsm.js